/* Routes for sidebar menu
  For a single entry: {
    name: Entry Display Name,
    icon: Entry Icon,
    ID: dashboardRoutes.[route name].ID,
    path: dashboardRoutes.[route name].path,
  }

  For a folder: {
    name: Folder Display Name,
    icon: Folder Icon,
    ID: random ID for key for component in the loop,
    children: [{
      name: Sub entry name,
      path: dashboardRoutes.[route name].path,
    }],
  }
*/
import { CgProfile } from "react-icons/cg";
import { MdBrandingWatermark } from "react-icons/md";
import { AudienceIcon, CampaignIcon } from "./sidebar icons/BrandProfile";

import dashboardLayoutRoutes from "../../../router/router components/dashboardLayoutRoutes";

const routes = [
  {
    name: "Profile",
    icon: CgProfile,
    ID: dashboardLayoutRoutes.profileDetailsRoute.ID,
    path: dashboardLayoutRoutes.profileDetailsRoute.path,
  },

  {
    name: "Brands",
    icon: MdBrandingWatermark,
    ID: dashboardLayoutRoutes.brandsAgencyList.ID,
    path: dashboardLayoutRoutes.brandsAgencyList.path,
  },

  {
    name: "Audience",
    icon: AudienceIcon,
    ID: dashboardLayoutRoutes.audienceListRoute.ID,
    path: dashboardLayoutRoutes.audienceListRoute.path,
  },

  {
    name: "Campaigns",
    icon: CampaignIcon,
    ID: dashboardLayoutRoutes.myCampaignRoute.ID,
    path: dashboardLayoutRoutes.myCampaignRoute.path,
  },

  // {
  //   name: "Channel Agents",
  //   icon: ChannelAgent,
  //   ID: dashboardLayoutRoutes.channelAgentSettingRoute.ID,
  //   path: dashboardLayoutRoutes.channelAgentSettingRoute.path,
  // },

  // {
  //   name: "WhatsApp Onboarding",
  //   icon: WhatsappOnboarding,
  //   ID: dashboardLayoutRoutes.whatsAppOnboardingPageRoute.ID,
  //   path: dashboardLayoutRoutes.whatsAppOnboardingPageRoute.path,
  // },
];

export default routes;
